"use client";


import { useEffect, useState } from "react";
import * as All from "@/element/common/elmntbase";

export default function InstagramFeed({ token }: any) {
    const [posts, setPosts] = useState<any[]>([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    const accessToken = token;

    useEffect(() => {
        async function fetchInstagram() {
            try {
                const res = await fetch(
                    `https://graph.instagram.com/me/media?fields=id,media_url,permalink,thumbnail_url,caption&access_token=${accessToken}`
                );
                const data = await res.json();

                if (data.error) {
                    setError(data.error.message);
                    setPosts([]);
                } else {
                    setPosts(data.data || []);
                }
            } catch {
                setError("Failed to load feed.");
            } finally {
                setLoading(false);
            }
        }

        if (accessToken) fetchInstagram();
    }, [accessToken]);

    if (!loading && posts.length === 0) {
        return null;
    }

    return (
        <div className="instagram_feed">
            <div className="element-wrapper">
                <div className="w-100">
                    {loading ? (
                        <div className="instagram-slider skeleton-container">
                            {[...Array(6)].map((_, i) => (
                                <div key={i} className="skeleton-box" />
                            ))}
                        </div>
                    ) : (
                        <>
                            {error && <p className="error">{error}</p>}

                            {posts.length > 0 ? (
                                <div className="instagram-slider">
                                    <All.Slider
                                        slidesPerView={5}
                                        spaceBetween={0}
                                        centeredSlides={false}
                                        speed={1500}
                                        autoplay={{ delay: 5000 }}
                                        loop={true}
                                        breakpoints={{
                                            0: { slidesPerView: 2 },
                                            571: { slidesPerView: 3 },
                                            992: { slidesPerView: 4 },
                                            1200: { slidesPerView: 5 },
                                        }}
                                        navigation={false}
                                        pagination={false}
                                    >
                                        {posts.map((post: any, i: number) => (
                                            <All.SliderItem key={post.id || i}>
                                                <div className="home-st5">
                                                    <section className="tc-instagram-st5">
                                                        <div className="cards">
                                                            <All.MotionLink
                                                                href={post.permalink}
                                                                target="_blank"
                                                                className="img wow fadeIn slow"
                                                                initial={{ opacity: 0, visibility: "hidden", x: -50 }}
                                                                whileInView={{ opacity: 1, visibility: "visible", x: 0 }}
                                                                transition={{ duration: 0.8, delay: (i + 1) * 0.2 }}
                                                                viewport={{ once: true }}
                                                            >
                                                                <img
                                                                    src={post.media_url}
                                                                    alt={post.caption || "Instagram Post"}
                                                                    className="img-cover"
                                                                />

                                                                <span className="icon">
                                                                    <i className="fab fa-instagram"></i>
                                                                </span>
                                                            </All.MotionLink>

                                                        </div>
                                                    </section>
                                                </div>
                                            </All.SliderItem>
                                        ))}
                                    </All.Slider>
                                </div>
                            ) : (
                                <></>
                                // <p style={{ textAlign: "center" }}>No posts found.</p>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
